import { useContext } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const OnboardingSalesBooking = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	
	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, onboardingSalesBooking: false}))
		startHere.set((p) => ({ ...p, show: true}))
	}
	
	const steps = [
		{
			target: '.onboardingSalesBookingFirstStep',
			title: "Booked Category",
			content: 'This section shows all customers with confirmed bookings.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.onboardingSalesBookingSecondStep',
			title: "Check-in Category",
			content: 'This section displays customers who have already checked in.',
			disableBeacon: true,
			placement: "bottom",
		},
		{
			target: '.onboardingSalesBookingThirdStep',
			title: "Check-out Category",
			content: 'This section shows customers who have completed their check-out.',
			disableBeacon: true,
			placement: "bottom",
		},
	]

	return (
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.onboardingSalesBooking)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="onboardingSalesBooking" 
			featureName="sales"
		/>
	);
}
